import { Link } from 'react-router';

import styles from './style.module.css';

// The quiet link back to the page a page was opened from, above its title.
export function BackLink({ to, children }) {
  return (
    <Link className={ styles.link } to={ to }>
      <span className={ styles.arrow } aria-hidden='true'></span>

      { children }
    </Link>
  );
}
